<template>
	<div class="ui-commmon-header">
			<img src="../../../assets/image/change-icon/back@2x.png" v-on:click='goBack()' class="ui-go-back">
			<h3>换购</h3>
			<img src="../../../assets/image/change-icon/b2_cart@2x.png" class="ui-cart" v-on:click='goCart()'>
			<span class="cart-number" v-if="cartNumber <= 100 && cartNumber > 0">{{ cartNumber }}</span>
			<span class="cart-number" v-if="cartNumber >= 100  && cartNumber > 0">99+</span>
	</div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex"
import { Header } from 'mint-ui'
import { HeaderItem } from '../../../components/common'
import { cartQuantity } from '../../../api/cart';

export default {
  name: "ProductListHeader",
  computed: {
    ...mapState({
			isOnline: state => state.auth.isOnline,
			user: state => state.auth.user,
			cartNumber: state => state.tabBar.cartNumber,
			detailInfo: state => state.detail.detailInfo
    }),
    ...mapGetters({
      isHasUnreadCount: 'isHasUnreadCount'
    }),
    isShowBack () {
			return true
    },
    getCarCount () {								
      if (this.cartNumber > 0 && this.cartNumber < 100) {
        return this.cartNumber
      } else if (this.cartNumber >= 100) {
        return '99+'
      }				
    }
  },
  methods: {
			...mapMutations({
				setCartNumber: 'setCartNumber',
			}),
			leftClick() {
        this.$router.go(-1)
			},
			goState() {
				this.$router.push('/search');
      },
      /*
			 *  getCarNumber: 获取购物车数量
			 */
			getCarNumber() {
				cartQuantity().then(res => {
					if (res) {
						this.setCartNumber(res.quantity);
					}
				})
			},
			/*
				goBack: 返回到上一页
			 */
			goBack() {
				this.$router.go(-1);
			},

			/*
			 *  goCart: 跳转到购物车
			 */
			goCart() {
				if (this.user) {
					this.$router.push({'name': 'cart', 'params': {type: 0}});
				} else {
					this.$router.push({'name': 'signin'});
				}
			}
	}
};
</script>

<style scoped lang='scss'>
  .header {
		@include header;
		background-color: #ed8b19;
  }
</style>


// WEBPACK FOOTER //
// src/page/repurchase-list/child/ProductListHeader.vue